import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ChevronDown, ChevronUp } from 'sushiweb/Icons';
import { Section, Header } from './styles';

const ExpandableSection = ({
    header,
    children,
    defaultExpanded,
}) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    return (
      <Section>
        <Header onClick={() => setIsExpanded(!isExpanded)}>
          {header}
          {isExpanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
        </Header>
        {isExpanded && children}
      </Section>
    );
};

ExpandableSection.propTypes = {
    header: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    defaultExpanded: PropTypes.bool,
};

ExpandableSection.defaultProps = {
    defaultExpanded: false,
};

export default ExpandableSection;
